/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_EventsInputs */

const en_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Events`)
};

const fr_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des événements`)
};

const de_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtereignisse`)
};

const it_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi totali`)
};

const ru_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего событий`)
};

const es_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

const zh_cn2_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总事件`)
};

const ja_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計イベント数`)
};

const hi_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल घटनाएँ`)
};

const pt_pt2_total_events = /** @type {(inputs: Total_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

/**
* | output |
* | --- |
* | "Total Events" |
*
* @param {Total_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const total_events = /** @type {((inputs?: Total_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_total_events(inputs)
	if (locale === "de") return de_total_events(inputs)
	if (locale === "it") return it_total_events(inputs)
	if (locale === "ru") return ru_total_events(inputs)
	if (locale === "es") return es_total_events(inputs)
	if (locale === "zh-CN") return zh_cn2_total_events(inputs)
	if (locale === "ja") return ja_total_events(inputs)
	if (locale === "hi") return hi_total_events(inputs)
	if (locale === "pt-PT") return pt_pt2_total_events(inputs)
	return en_total_events(inputs)
});